export const SCHEDULE_DAY_ROW_HEIGHT_PX = 68;
export const SCHEDULE_DAY_COLUMN_WIDTH_PX = 104;
export const SCHEDULE_HOUR_COLUMN_WIDTH_PX = 60;

export const SCHEDULE_TIME_SLOT_WINDOW_HEIGHT_OFFSET = -14;
export const SCHEDULE_TIME_SLOT_WINDOW_TOP_OFFSET = 4;
export const SCHEDULE_TIME_SLOT_WINDOW_VERTICAL_INSET_PX = 4;
export const SCHEDULE_TIME_SLOT_WINDOW_DAY_COLUMN_OFFSET_PX = 1.5;

export const SCHEDULE_SNAP_MINUTES = 1;
export const SCHEDULE_MIN_DURATION_MINUTES = 15;
export const SCHEDULE_DEFAULT_DURATION_MINUTES = 60;

export const SCHEDULE_HOURS_IN_DAY = 24;
export const SCHEDULE_MINUTES_IN_HOUR = 60;
